export default {
  userInfo: {},
  shouldChangePassword: false,
};
